import { MarketingHeroContainer, MarketingContentContainer } from "@platform/features/marketing";

export default function MarketingHome() {
  return (
    <>
      <div className="flex flex-col gap-8 py-4">
        <MarketingHeroContainer />
        <MarketingContentContainer />
      </div>
    </>
  );
}


